import React from 'react';

import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Box from '@material-ui/core/Box'

import {setImgFromCache } from '../../utils/cacheUtils';

const PurchaseListItem =React.memo((props)=>{
  const {
    purchase,
    onClick,
    selected=false,
  }=props

  const handleAdsClick=React.useCallback(()=>{
    if(!!onClick) onClick(purchase)
  },[purchase,onClick])

  const imgRef=React.useRef()

  React.useEffect(()=>{
    let imageURL=purchase?.thumb_photoURL||""
    if(imageURL.startsWith("/")){
      //load cache
      setImgFromCache(imageURL,imgRef,()=>{

      },(e)=>{
        console.log("error",e)
      })
    }else if(imageURL.startsWith("http")){
      //load from URL
      if(!!imgRef.current) imgRef.current.src=imageURL
    }else{
      if(!!imgRef.current) imgRef.current.src="/static/no-image.png"
    }
  },[purchase])

  const bgColor=React.useMemo(()=>{
    switch(purchase?.status){
      case "Ditinjau":
        return "#FFEE33"
      case "Aktif":
        return "#EEFFEE"
      case "Ditolak":
        return "#FFEEEE"
      default:
        return "initial"
    }
  },[purchase])

  return (
    <>
      <ListItem
        button
        onClick={handleAdsClick}
        //divider
        style={{
          height:"100px",
          overflowY:"hidden",
          padding:"0px 8px",
          border:selected?"1px solid green":null,
          backgroundColor:bgColor,
        }}
        disableGutters
      >
        <ListItemIcon>
          <img
            style={{
              height:"80px",
              width:"80px",
              objectFit:"contain",
              border:"1px solid black",
            }}
            ref={imgRef}
            src="#"
            alt="iklan"
          />
        </ListItemIcon>
        
        <ListItemText
          primary={purchase?.purchaseName}
          secondary={<span>{purchase?.customerEmail}<br/>
            Tagihan<sup style={{color:"black",fontWeight:"bold"}}> Rp </sup>
            <span style={{color:"black",fontWeight:"bold",fontSize:"24px"}}>{" "+purchase?.billableAmount?.toLocaleString("ID-id")}</span>
            {" | "}
            Dibayar<sup style={{color:"black",fontWeight:"bold"}}> Rp </sup>
            <span style={{color:"black",fontWeight:"bold",fontSize:"24px"}}>{" "+purchase?.paymentAmount?.toLocaleString("ID-id")}</span>

            <span style={{color:"black",position:"absolute",top:"16px",right:"8px"}}>{(!!purchase?.paymentURL)?"Bukti Bayar":""}</span>
            <span style={{color:"black",position:"absolute",bottom:"16px",right:"8px"}}>{purchase?.status}</span>
          </span>}
          secondaryTypographyProps={{style:{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}}
          primaryTypographyProps={{style:{fontWeight:"bold"}}}
          style={{
            paddingLeft:"16px",
          }}
        />
      </ListItem>
      <Divider style={{margin:"0px 8px"}}/>
    </>
  )
})

export default PurchaseListItem